export var ProductBidStatus;
(function (ProductBidStatus) {
    ProductBidStatus["Submitted"] = "Submitted";
    ProductBidStatus["Won"] = "Won";
    ProductBidStatus["Lost"] = "Lost";
    ProductBidStatus["Cancelled"] = "Cancelled";
})(ProductBidStatus || (ProductBidStatus = {}));
